export class SettimanaConsegnaDTO {
  settimanaConsegna: number;
  utenteModifica: string;
}
